<template>
  <div>
    <div>
      <div class="columns is-vcentered is-mobile">
        <div class="column is-narrow">
          <i class="fas fa-users fa-lg"></i>
        </div>
        <div class="column">
          <span><h3 class="title is-5">Anggota</h3></span>
        </div>
        <div class="column is-narrow is-hidden-tablet">
          <a
            class=""
            @click="open = !open"
            aria-controls="contentIdForA11y1"
          >
            <i class="fas fa-caret-up" v-if="open"></i>
            <i class="fas fa-caret-down" v-else></i>
          </a>
        </div>
      </div>

      <b-collapse v-if="open" :open="open" aria-id="contentIdForA11y1" class="card-anggota" style="overflow: inherit;">
        <div class="scroll-anggota">
          <div class="columns is-multiline">
            <!-- LOOP DISINI -->
            <div class="column is-12-fullhd is-12-widescreen is-12-desktop is-12-tablet is-12-mobile" v-for="(member, key) in students" :key="key">
              <div class="anggota-grup">
                <a href="#">
                  <avatar avatar_url="/assets/img/no-img.png"></avatar>
                  <p class="tooltip" :data-tooltip="detailMember(member, 'name')">
                    {{ !isEmpty(detailMember(member, 'name')) ? `${detailMember(member, 'name').substring(0, 15)}...` : '' }}
                  </p>
                </a>
              </div>
            </div>
            <!-- END LOOP -->
          </div>

          <div class="columns" v-if="students.length > 0">
            <div class="column">
              <pagination v-if="!loading_get_members" :dataProvider="dataProvider" :clickHandler="getMembers"></pagination>
              <spinner-loading v-if="loading_get_members"></spinner-loading>
            </div>
          </div>
        </div>

        <div class="columns" v-if="students.length <= 0">
          <div class="column">
            <div class="card-download-right">
              <blockquote><p class="has-text-grey has-text-centered"><small>Tidak ada anggota.</small></p></blockquote>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>

    <br>
  </div>
</template>

<script>
import { GROUP } from '~/consts';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    group: {
      type: Object,
      required: true
    }, 
    members: {
      type: Array,
      default: () => {}
    },
    loading_get_members: {
      type: Boolean,
      default: false
    },
    dataProvider: {
      type: Object,
      required: true
    },
    getMembers: {
      type: Function,
      required: true
    }
  },

  computed: {
    students() {
      return collect(this.members).where('role', '==', 'MEMBER').toArray();
    }
  },

  data() {
    return {
      open: this.isOpen
    }
  },

  methods: {
    detailMember(member, attribute) {
      const user = member.user;

      if (this.group.type === 'ACADEMIC') {
        return member.universityUser[attribute];
      }

      if (attribute == 'type') {
        return member.role == 'OWNER' || member.role == 'ADMIN' ? 'L' : 'S';
      } else {
        return member.user[attribute];
      }
    },
  }
}
</script>